import { makeAutoObservable, runInAction } from 'mobx';
import { showToast } from '../../../utils/toast';
import { COMPANYPROFILEINITIAL } from '../constants/onboard.constant';
import { companyURL, myCompanyURL } from '../../User/api/url';
import { handleFetch } from '../../../utils/handleFetch';

class CompanyProfileStore {
	companyProfile = COMPANYPROFILEINITIAL;
	isCompanyProfileChanged = false;

	constructor() {
		makeAutoObservable(this);
	}

	getCompany = async () => {
		return await handleFetch({
			url: myCompanyURL,
			method: 'GET',
			onSuccess: (data) => runInAction(() => (this.companyProfile = data)),
		});
	};

	updateCompany = async () => {
		return showToast.promise(
			(async () => {
				const success = await handleFetch({
					url: companyURL(this.companyProfile?._id),
					method: 'PUT',
					body: this.companyProfile,
					onSuccess: (data) => {
						runInAction(() => {
							this.companyProfile = data;
							this.isCompanyProfileChanged = false;
						});
					},
				});
				if (!success) throw new Error('Failed to update company');
				return success;
			})(),
			{
				loading: 'Updating company...',
				success: 'Company updated successfully!',
				error: 'Failed to update company',
			},
		);
	};

	handleChangeCompanyProfile = (e) => {
		const { id, value } = e.target;
		this.companyProfile[id] = value;
		this.isCompanyProfileChanged = true;
	};
}

export const companyProfileStore = new CompanyProfileStore();
